import Routing from './Routes/Routing';
import './styles/global.css'
function App() {
  return (
    <div>
     <Routing />
    </div>
  );
}


export default App;
